import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Card, Collapse, ListItemButton } from "@mui/material";
import { ReactNode, useState } from "react";

type Props = {
  header: ReactNode;
  children: ReactNode;
  defaultExpanded?: boolean;
  rowHeight?: number;
  dataTestId?: string;
};

export const CollapsibleListItem = ({
  header,
  children,
  defaultExpanded = false,
  rowHeight = 44,
  dataTestId,
}: Props) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Card
      data-testid={dataTestId}
      sx={{
        borderRadius: "5px",
        boxShadow: "none",
        backgroundColor: "transparent",
        overflow: "hidden",
        border: "1px solid",
        borderColor: expanded ? "divider" : "transparent",
        transition: "border-color .15s",
      }}
    >
      <ListItemButton
        onClick={() => setExpanded((value) => !value)}
        disableGutters
        aria-expanded={expanded}
        sx={{
          m: 0,
          width: "100%",
          px: 2,
          py: 0,
          height: rowHeight,
          minHeight: rowHeight,
        }}
      >
        <Box className="flex w-full items-center gap-3 min-w-0">
          {header}
          <ExpandMoreIcon
            fontSize="small"
            sx={{
              flexShrink: 0,
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform .2s",
              color: "text.secondary",
            }}
          />
        </Box>
      </ListItemButton>
      <Collapse in={expanded} unmountOnExit>
        <Box sx={{ px: 2, pb: 2 }}>{children}</Box>
      </Collapse>
    </Card>
  );
};

export default CollapsibleListItem;
